<!--
 * @Author: Shao Wei
 * @Date: 2022-10-20 16:07:11
 * @LastEditors: Shao Wei
 * @LastEditTime: 2022-10-21 19:03:24
 * @Description: file content
 * @FilePath: /leopard-web-vehicle/src/views/finance/alipayConfigContent.vue
-->
<template>
    <div class="box-wrap">
        <el-form
            ref="alipayContent"
            :model="alipayConfigData"
            :rules="rules"
            label-position="top"
        >
            <el-col :span="24">
                <el-form-item
                    prop="state"
                    label="是否开启："
                >
                    <el-radio-group
                        v-model="alipayConfigData.state"
                    >
                        <el-radio :label="1">开启</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item
                    prop="withholdTime"
                    label="执行时间（每天）："
                >
                    <!-- 禁止清空（clearable=false）、手动输入/编辑(editable=false) 主要解决时间清空后后续流程走不了 -->
                    <el-time-picker
                        v-model="alipayConfigData.withholdTime"
                        placeholder="请选择时间"
                        value-format="HH:mm:ss"
                        :clearable="false"
                        :editable="false"
                    >
                    </el-time-picker>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item>
                    <p>*开启后，自动代扣「应收日期」为当日的应收项</p>
                    <p>*代扣发起前，请确保应收已调整无误</p>
                </el-form-item>
            </el-col>
        </el-form>
    </div>
</template>
<script>
export default {
  name: 'alipayConfigContent',
  props: {
    alipayConfigData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
    }
  },
  methods: {
    // 表单校验
    formValidate () {
      return new Promise((resolve, reject) => {
        this.$refs.alipayContent.validate((valid) => {
          if (valid) {
            resolve(this.alipayConfigData)
          } else {
            reject()
          }
        })
      })
    },
    formResetFields () { this.$refs.alipayContent && this.$refs.alipayContent.resetFields() }
  },
  computed: {
    rules () {
      return {}
    }
  }
}
</script>
